<template>
  <div class="credits-edit-section">
    <loading-state :state="state"></loading-state>
    <div v-if="(credit && credit.variation == null) || (credit && credit.variation && !credit.variation.is_frozen)">

      <!-- Credits Edited -->
      <div class="help-text">
        The Intelligent Dynamic Player Credit Points may change dynamically based on the various situations for the match. 
      </div>
      <div v-if="credit && credit.variation">
        <credit-variation
          :credit="credit"
          :title="'Credits Edited'"
          :creditSource="'variant'"
          @creditVariation="editPoints"
          @playerSelected="onPlayerSelected"
        ></credit-variation>
      </div>

      <!-- Default Credits -->
      <credit-variation
        :credit="credit"
        :title="'Intelligent Dynamic Credit Points'"
        :creditSource="'roanuz'"
        @creditVariation="editPoints"
        @selectAllPlayers="selectAllPlayers"
        @playerSelected="onPlayerSelected"
     ></credit-variation>
    </div>
    
    <div v-if="state.isLoaded() && !(credit)">
      <div class="match-status title-and-tools" v-if="state.isLoaded()">
        <p class="match-started" v-if="match.status.isCompleted">Match is already completed. You can't edit the player credit points for this match</p>
        <p class="match-started" v-else>Match is already started. You can't edit the player credit points for this match</p>
      </div>
    </div>
    
    <div v-if="credit && credit.variation && credit.variation.is_frozen">
      <loading-state :state="state"></loading-state>
    <!-- frozen list -->
      <div class="help-text">
        Static Credit Points: The following player will have static credits points which will not change over the time for the match.
      </div>
      <credit-variation
        :credit="credit"
        :title="'Static Credit Points'"
        :creditSource="'variant'"
        @creditVariation="editPoints"
        @playerSelected="onPlayerSelected"
      ></credit-variation>
    </div>

    <app-hang-dailog
      :show="dailogPacket.show"
      yesText="" class="player-draft"
    >
      <loading-state :state="state"></loading-state>
      <div class="edit-player-points" id="player" v-if="credit && credit.players">
        <div class="box">
          <div class="box-header" @click="touchEnd">
            <div class="main">
              <h3>Edit Credit Points</h3>
            </div>
            <div class="buttons">
              <div>
                <button class="clean box cancel" @click="onChooseDailogCancel()">Cancel</button>
                <button class="clean fullcolor" :disabled="saveState.isLoading() || vatError == true" @click="saveCreditVariation()">
                  <span>Save</span>
                </button>
              </div>
            </div>
          </div>
          <div v-if="fantasyDraft && fantasyDraft.players">
            <div class="player" v-for="(playerInfo, index) in fantasyDraft.players" :key="index">
              <button class="remove-player black compact" @click="removePlayer(playerInfo.playerkey, index)">X</button>
              <div class="left-content">
                <div><span>New Credit</span><input type="number" id="number_field" @keyup="checkVatId(playerInfo.credits)" v-model="playerInfo.credits"></div>
                <div class="credit-points"><span>Current Credit:{{credit.players[playerInfo.playerkey].fantasyCredit.credit_value | locale('-')}}</span></div>
              </div>
              <div class="right-content">
                <div class="head">{{credit.players[playerInfo.playerkey].name}}</div>
                <div>{{credit.players[playerInfo.playerkey].seasonal_role}}</div>
                <div class="credit-points">RCA Credit:<span v-if="credit.players[playerInfo.playerkey].fantasyCredit.credit_src === 'variant'">{{credit.players[playerInfo.playerkey].fantasyCredit.original_credit_value | locale('-')}}</span>
                  <span v-else>{{credit.players[playerInfo.playerkey].fantasyCredit.credit_value | locale('-')}}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-hang-dailog>

    <div class="app-right-dailog" :class="{visible: selectedPlayer != null}">
      <div class="tools"><button @click="selectedPlayer=null" class="box">Close</button></div>
      <div class="content"  v-if="selectedPlayer">
        <cricket-match-player
          :player="selectedPlayer"
          :match="match"
          :hideStats="true"></cricket-match-player>
        <div v-if="credit && credit.grouped">
          <div class="dl-box">
            <dl>
              <dt>Credit</dt>
              <dd>{{credit.players[selectedPlayer.key].fantasyCredit.credit_value | locale}}</dd>
              <dt>Season</dt>
              <dd>{{credit.players[selectedPlayer.key].fantasyCredit.season_points | locale('-')}}</dd>
              <dt>Recent points</dt>
              <dd>{{credit.players[selectedPlayer.key].fantasyCredit.recent.points | locale}}</dd>
              <dt>Avg</dt>
              <dd>{{credit.players[selectedPlayer.key].fantasyCredit.recent.average_points_per_match | locale}}</dd>
              <dt>Overall points</dt>
              <dd>{{credit.players[selectedPlayer.key].fantasyCredit.overall.points | locale}}</dd>
            </dl>
          </div>
        </div>
        <div v-if="points && !credit">
          <div class="dl-box">
            <dl>
              <dt>Points</dt>
              <dd>{{points.players[selectedPlayer.key].fantasyPoints.match_points | locale('-')}}</dd>
              <dt>Season</dt>
              <dd>{{points.players[selectedPlayer.key].fantasyPoints.season_points | locale('-')}}</dd>
              <dt>Bat</dt>
              <dd>{{points.players[selectedPlayer.key].fantasyPoints.calculation.bat | locale('-')}}</dd>
              <dt>Bowl</dt>
              <dd>{{points.players[selectedPlayer.key].fantasyPoints.calculation.bowl | locale('-')}}</dd>
              <dt>Field</dt>
              <dd>{{points.players[selectedPlayer.key].fantasyPoints.calculation.field | locale('-')}}</dd>
              <dt>XI</dt>
              <dd>{{points.players[selectedPlayer.key].fantasyPoints.calculation.playing_xi | locale('-')}}</dd>
              <dt>SR</dt>
              <dd>{{points.players[selectedPlayer.key].fantasyPoints.calculation.strike_rate | locale('-')}}</dd>
              <dt>Econ.</dt>
              <dd>{{points.players[selectedPlayer.key].fantasyPoints.calculation.economy_rate | locale('-')}}</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>

     <div class="static-dialog-box">
      <app-dailog
        :show="dailogBox.show"
        :showTitle="false"
        @onCancel="hideDialog" id="close-box">
        <div>
          <span>Note:</span>
          <ul>
            <li>If the player is added officially, it will not be automatically added to your list. You need to add the player's manually.</li>
            <li>If the player is removed officially from the squad, it will not be automatically removed from your list.</li>
          </ul>
        </div>
        <div class="btn-wrap">
        <button class="freezen blue" :disabled="dailogPacket.show" @click="freezeCredits()">Continue</button>
          <button class="clean fullcolor" @click="hideDialog">Cancel</button>
        </div>
      </app-dailog>
    </div>
  </div>
</template>
<script>
import { AppState, DataState, AppKind } from '@/state'
import AppEvents from '@/appevents'
import CreditVariation from '@/components/workflow/cricket/CreditVariation.vue'
import { FantasyDraft, FantasyDraftPlayer } from '@/models/workflow/cricket/fantasy'
import { FantasyCreditVariation } from '@/models/workflow/cricket/fantasy'
import { CricketMatch } from '@/models/cricket/match'

export default {
  props: {
    match: Object
  },
  components: {
    'CreditVariation': CreditVariation
  },
  data () {
    return {
      matchKey: this.$route.params.key,
      credit: null,
      points: null,
      creditsEdited: null,
      frozenCredits: null,
      selectedPlayer: null,
      state: DataState.newLoading(),
      saveState: DataState.newNotInit(),
      fantasyDraft: new FantasyDraft(),
      fantasyDraftPlayer: new FantasyDraftPlayer(),
      dailogPacket: {
        show: false
      },
      dailogBox: {
        show: false
      },
      newPoints: null,
      isTableViewDefalut: false,
      isTableViewEdited: false,
      hideBox: true,
      hideDefaullt: true,
      freezePoints: false,
      variation : null,
      vatError: false
    }
  },
  created () {
    this.$globalEvents.$on(AppEvents.cricketMatchUpdate, this.onMatchUpdated)
  },
  beforeDestroy () {
    this.$globalEvents.$off(AppEvents.cricketMatchUpdate, this.onMatchUpdated)
  },
  watch: {
    'match.key' (to, from) {
      if (this.match.key !== this.match.key) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    },
  },
  mounted () {
    this.onViewOpenned()
     if (this.$route.path.indexOf('/workflow') > -1) {
      AppState.updateAppKind(AppKind.Workflow)
    }
  },
  methods: {
    selectAllPlayers () {
      this.dailogBox.show = true
    },
    hideDialog () {
      this.dailogBox.show = false
    },
    onViewOpenned (useFresh) {
      if (this.match.status.isNotStarted) {
        this.match.creditVariations(true).then(credit => {
          this.credit = credit
          this.points = null
          this.state.changeToLoaded()
        }).catch((error) => {
          console.error(error)
          this.state.changeToError(error)
        })
      } else {
        this.state.changeToLoaded()
      }
    },
    editPoints (playerKey, index) {
      this.dailogPacket.show = true
      this.fantasyDraftPlayer.playerkey = playerKey
      this.newPoints = this.credit.players[playerKey].fantasyCredit.credit_value
      this.fantasyDraftPlayer.credits = this.newPoints
      this.fantasyDraft.addPlayerDraft(this.fantasyDraftPlayer)
      this.fantasyDraftPlayer = new FantasyDraftPlayer()
    },
    removePlayer (playerkey, index) {
      this.fantasyDraft.removePlayerDraft(index)
    },
    onChooseDailogCancel () {
      this.dailogPacket.show = false
      this.fantasyDraft = new FantasyDraft()
    },
    onMatchUpdated (match) {
      if (!this.state.isLoaded()) { return }
      this.onViewOpenned(true)
    },
    prepareToReopen () {
      this.credit = null
    },
    onPlayerSelected (playerKey) {
      this.selectedPlayer = this.match.players[playerKey]
    },
    removePlayerList (key) {
      this.credit.players[key].fantasyCredit.credit_src =  'roanuz'
      this.saveCreditVariation()
    },
    preparePayload () {
      const newDraft = new FantasyDraft()
      if (this.fantasyDraft.players) {
        this.fantasyDraft.players.forEach((player) => {
          newDraft.addPlayerDraft(player)
        })
      }
      this.credit.playerKeys.forEach((key) => {
        const variationCredit = this.credit.players[key].fantasyCredit.credit_src
        if (variationCredit == 'variant') {
          const newDraftPlayer = new FantasyDraftPlayer()
          newDraftPlayer.credits = this.credit.players[key].fantasyCredit.credit_value
          newDraftPlayer.playerkey = key
          newDraft.addPlayerDraft(newDraftPlayer)
        }
      })
      return newDraft.players
    },
    saveCreditVariation () {
      this.saveState.changeToLoading()
      let playersDraft = this.preparePayload()
      this.match.save(this.matchKey, playersDraft).then((editPlayer) => {
        this.credit = editPlayer
        this.dailogPacket.show = false
        this.fantasyDraft = new FantasyDraft()
      }).then((res) => {
        this.saveState.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.saveState.changeToError(error)
        this.dailogPacket.show = false
      })
    },
    freezeData () {
      const newDraft = new FantasyDraft()
      this.credit.playerKeys.forEach((key) => {
        const newDraftPlayer = new FantasyDraftPlayer()
        newDraftPlayer.credits = this.credit.players[key].fantasyCredit.credit_value
        newDraftPlayer.playerkey = key
        newDraft.addPlayerDraft(newDraftPlayer)
      })
      return newDraft.players
    },
    freezeCredits () {
      let freezePlayers = this.freezeData()
      if (this.credit.variation == null) {
        const variation = new FantasyDraft()
        this.credit.variation = variation
      }
      this.credit.variation.is_frozen == true
      this.match.save(this.matchKey, freezePlayers, true).then((editPlayer) => {
        this.credit = editPlayer
        this.state.changeToLoaded()
        var element = document.getElementById('close-box')
        element.classList.remove('show')
        element.classList.add('hide')
        this.freezePoints = !this.freezePoints
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
    touchEnd (event) {
      event.preventDefault()
      var width = document.body.clientWidth
      if (width < 767) {
        var element = document.getElementById('player')
        element.classList.add('change-height')
      }
    },
    checkVatId (value) {
      var vatIdRegex =  /[+-]?([0-9]*[.])?[0-9]+/
      var element = document.getElementById('number_field')
      if (!value) {
        element.style.borderColor='red';
        this.vatError = true
      } else if(!vatIdRegex.test(value)) {
        element.style.borderColor='red';
        this.vatError = true
      } else {
        element.style.borderColor='green';
        this.vatError = false
      }
   }
  }
}
</script>
